export type Nullish<T> = T | null | undefined;

export function isNullish<T>(value: Nullish<T>): value is null | undefined {
  return value === null || value === undefined;
}

export function isNotNullish<T>(value: Nullish<T>): value is T {
  return !isNullish(value);
}

export function isNotNullishValues<T extends object>(
  obj: T
): obj is { [K in keyof T]: Exclude<T[K], Nullish<T>> } {
  for (const key in obj) {
    if (isNullish(obj[key])) {
      return false;
    }
  }
  return true;
}

export function isNotNullishAll<T>(arr: (T | null | undefined)[]): arr is T[] {
  return arr.every(isNotNullish);
}
